import { FC, PropsWithChildren } from "react";

export const DummyComponent: FC<PropsWithChildren> = ({ children }) => {
    return children;
};

export const DummyComponentWithoutChildren: FC = () => {
    return null;
};

export const toPx = (value: number | string): string => {
    return typeof value === "number" ? `${value}px` : value;
};
